import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
    apiKey: "AIzaSyCQX6yuyfNDmyybvVDpFarPamyJ8hTfJBI",
    authDomain: "hi-blinds-contador.firebaseapp.com",
    databaseURL: "https://hi-blinds-contador-default-rtdb.firebaseio.com",
    projectId: "hi-blinds-contador",
    storageBucket: "hi-blinds-contador.firebasestorage.app",
    messagingSenderId: "318979042064",
    appId: "1:318979042064:web:9885614160bb8b1a4e9395"
  };

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

export default database;